import qs from 'qs'
import { useCallback, useEffect, useState } from 'react'

import { getAllTankHistoriesApi } from '@/apis/tankHistories'
import { API_LIMIT } from '@/constants/api'
import useQuery from '@/hooks/useQuery'
import useQueryPage from '@/hooks/useQueryPage'
import { GetAllTankHistoryRequest } from '@/types/apis/tankHistory/GetAllTankHistoriesRequest'
import { GetAllTankHistoryResponse } from '@/types/apis/tankHistory/GetAllTankHistoriesResponse'

import { PageQueryParams } from '../Tank/Tank.hooks'

export const useTankHistories = () => {
  const currentPage = useQueryPage()
  const query = useQuery()
  const [page, setPage] = useState(currentPage)
  const [getTankHistoriesLoading, setGetTankHistoriesLoading] = useState(false)
  const [getTankHistoriesResponse, setTankHistoriesResponse] = useState<GetAllTankHistoryResponse>()

  const filterToQuery = (filter: { page?: number }): string => {
    const filterQuery: PageQueryParams = {}

    if (filter.page) {
      filterQuery.page = filter.page
    }

    return qs.stringify(filterQuery)
  }

  const get = useCallback(
    async (request: GetAllTankHistoryRequest) => {
      try {
        setGetTankHistoriesLoading(true)
        const res = await getAllTankHistoriesApi({ ...request, limit: API_LIMIT, page })

        setTankHistoriesResponse(res)
      } finally {
        setGetTankHistoriesLoading(false)
      }
    },
    [page]
  )

  useEffect(() => {
    const page = query.get('page')
    setPage(page ? Number(page) : 1)
  }, [query])

  return {
    page,
    pageSize: API_LIMIT,
    getTankHistories: get,
    getTankHistoriesResponse,
    getTankHistoriesLoading,
    filterToQuery,
  }
}
